import type { ReactNode } from 'react';
import { CoinIcon, GemIcon } from './CurrencyIcon';
import { formatCompact } from '@/util/formatNumber';

interface PillProps {
  icon: 'coin' | 'gem';
  children: ReactNode;
}

export function Pill({ icon, children }: PillProps) {
  // Currency chips always carry a number — render it compact (12.3K / 1.5M) so a
  // huge balance can't widen the header and push the rest of the row off-screen.
  const content = typeof children === 'number' ? formatCompact(children) : children;
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px 4px 6px',
        background: 'rgba(0,0,0,0.35)',
        border: '1px solid var(--hairline)',
        borderRadius: 99,
        fontFamily: 'var(--f-mono)',
        fontSize: 12,
        fontWeight: 600,
        flexShrink: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {icon === 'coin' ? <CoinIcon /> : <GemIcon />}
      <span>{content}</span>
    </div>
  );
}
